import React from 'react';
import _ from 'lodash';
import { useRouter } from 'next/router';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import { useProductFiltersApplied } from 'src/hooks/use-product-filters-applied';

import Menu from 'components/menu';
import ContentWrapper from 'components/core/content-wrapper';

export default function SalePage() {
  const router = useRouter();
  const { dispensary } = useDispensary();
  const { specialId } = router.query;

  const { products, totalPages, loading } = useDispensaryProducts({
    filters: { specialId, specialType: `sale`, isOnSpecial: true },
  });

  const productFiltersApplied = useProductFiltersApplied();
  const displaySidebar = !(_.isEmpty(products) && !productFiltersApplied);

  if (!dispensary) {
    return null;
  }

  return (
    <ContentWrapper>
      <Menu
        products={products}
        loading={loading}
        dispensary={dispensary}
        page='sale special'
        specialId={specialId}
        specialType='sale'
        skipCurrentFilters
        totalPages={totalPages}
        displaySidebar={displaySidebar}
      />
    </ContentWrapper>
  );
}
